var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52610",
    "data-name": "Group 52610",
    transform: "translate(-30 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1620",
    "data-name": "Rectangle 1620",
    transform: "translate(30 29)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_13_",
    "data-name": "svgexport-7 (13)",
    transform: "translate(43.895 41.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91005",
    "data-name": "Path 91005",
    d: "M57.26,42.61a1,1,0,0,0,0-1.42l-2.74-2.74A14.83,14.83,0,0,0,56,32,15,15,0,1,0,41,47a14.83,14.83,0,0,0,6.45-1.48l2.74,2.74a1,1,0,0,0,1.42,0l.7-.7L58,53.21,62.21,49l-5.65-5.66ZM41,43A11,11,0,1,1,52,32,11,11,0,0,1,41,43Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91006",
    "data-name": "Path 91006",
    d: "M41,25a4,4,0,0,0-4,4h2a2,2,0,1,1,2,2,1,1,0,0,0-1,1v3h2V32.87A4,4,0,0,0,41,25Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91007",
    "data-name": "Path 91007",
    d: "M40,37h2v2H40Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91008",
    "data-name": "Path 91008",
    d: "M18,2H2V18H18ZM6,14l4-8,4,8Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91009",
    "data-name": "Path 91009",
    d: "M18,24H2V40H18ZM12.31,36H7.69L5.38,32l2.31-4h4.62l2.31,4Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91010",
    "data-name": "Path 91010",
    d: "M18,46H2V62H18ZM10,58a4,4,0,1,1,4-4A4,4,0,0,1,10,58Z",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTest);
export default __webpack_public_path__ + "static/media/NewTest.ac1520fa4974c7a47e373c5671c708a9.svg";
export { ForwardRef as ReactComponent };